package com.wintermar.inspection.core.ui.component.badge

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.badge.variant.BadgeLabel
import com.wintermar.inspection.core.ui.component.badge.variant.BadgeSizeType
import com.wintermar.inspection.core.ui.component.badge.variant.BadgeType
import com.wintermar.inspection.core.ui.component.badge.variant.toModel
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun Badge(
    type: BadgeType,
    label: String,
    size: BadgeSizeType = BadgeSizeType.SMALL,
    strong: Boolean = false,
    trailingIcon: DrawableResource? = null,
    leadingIcon: DrawableResource? = null,
    clickable: Boolean = false,
    horizontalPadding: Dp? = null,
    onClick: () -> Unit = {}
) {
    val variant = type.toModel(badgeSizeType = size, strong = strong)
    val dimension = LocalAppTheme.current.dimension

    Row(
        modifier = Modifier
            .clip(RoundedCornerShape(dimension.radius.full))
            .background(
                color = variant.color.backgroundColor,
            )
            .then(
                if (clickable) Modifier.clickable { onClick() } else Modifier
            )
            .then(
                if (variant.color.borderColor != Color.Transparent) Modifier
                else {
                    Modifier
                        .border(
                            width = 1.dp,
                            color = variant.color.borderColor,
                            shape = RoundedCornerShape(dimension.radius.full)
                        )
                }
            )
            .padding(
                vertical = variant.size.verticalPadding,
                horizontal = horizontalPadding ?: variant.size.horizontalPadding
            ),
        horizontalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space1
        ),
        verticalAlignment = Alignment.CenterVertically
    ) {
        leadingIcon?.let {
            Icon(
                painter = painterResource(it),
                modifier = Modifier.size(variant.size.iconSize),
                contentDescription = size.name
            )
        }
        BadgeLabel(
            label = label,
            sizeType = size,
            textColor = variant.color.textColor
        )
        trailingIcon?.let {
            Icon(
                painter = painterResource(it),
                modifier = Modifier.size(variant.size.iconSize),
                contentDescription = size.name
            )
        }
    }
}
